import { render, staticRenderFns } from "./TrayectoriaLaboralComponent.vue?vue&type=template&id=dc0cee54"
import script from "./TrayectoriaLaboralComponent.vue?vue&type=script&lang=js"
export * from "./TrayectoriaLaboralComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports